import { App } from "vue";

import '@progress/kendo-theme-default/dist/all.css';
import 'bootstrap';
import { Grid, GridToolbar } from "@progress/kendo-vue-grid";
import ProductsList from './components/ProductsList.vue';
import ProductsSearchByFamily from './components/SearchProductsByFamily.vue';
import SearchProductsFull from './components/SearchProductsFull.vue';
import { IntlProvider, LocalizationProvider } from '@progress/kendo-vue-intl';
import MyAccountOrders from "./components/MyAccountOrders.vue";
import MyAccountProductsList from "./components/MyAccountProductsList.vue";

declare global {
	interface String {
		format(...string: string[]): string;
	}
	interface Number {
		toCurrencyString(locale: string): string;
    }
}

class MainRegistrations {
	init = function (app: App): void {
		// register string format on string prototype
		if (!String.prototype.format) {
			String.prototype.format = function () {
				var args = arguments;
				return this.replace(/{(\d+)}/g, function (match, number) {
					return typeof args[number] != 'undefined'
						? args[number]
						: match
						;
				});
			};
		}


		if (!(Object as any).compare)
			(Object as any).compare = function (obj1: any, obj2: any) {
				//Loop through properties in object 1
				for (var p in obj1) {
					//Check property exists on both objects
					if (obj1.hasOwnProperty(p) !== obj2.hasOwnProperty(p)) return false;

					switch (typeof (obj1[p])) {
						//Deep compare objects
						case 'object':
							if (!(Object as any).compare(obj1[p], obj2[p])) return false;
							break;
						//Compare function code
						case 'function':
							if (typeof (obj2[p]) == 'undefined' || (p != 'compare' && obj1[p].toString() != obj2[p].toString())) return false;
							break;
						//Compare values
						default:
							if (obj1[p] != obj2[p]) return false;
					}
				}

				//Check object 2 for any extra properties
				for (var p in obj2) {
					if (typeof (obj1[p]) == 'undefined') return false;
				}
				return true;
			};

		if (!Number.prototype.toCurrencyString) {
			Number.prototype.toCurrencyString = function (locale: string) {
				return "€ " + this.toLocaleString(locale, { minimumFractionDigits: 2 });
            }
        }

		// components
		app.component("grid", Grid);
		app.component("grid-toolbar", GridToolbar);		
		app.component("products-list", ProductsList);
		app.component("products-search-by-family", ProductsSearchByFamily);
		app.component("products-search-full", SearchProductsFull);
		app.component("myaccount-orders", MyAccountOrders);
		app.component("myaccount-products", MyAccountProductsList);
		app.component('intl-provider', IntlProvider);
		app.component('localization-provider', LocalizationProvider);
	};
}

export default new MainRegistrations();
